import apiClient from '../client';

/**
 * GET /loyalty/account
 * Returns balance, config, and lifetime stats for the logged-in customer.
 */
export const getLoyaltyAccount = async () => {
  const { data } = await apiClient.get('/loyalty/account');
  return data;
};

/**
 * GET /loyalty/transactions?page=0&size=20
 */
export const getLoyaltyTransactions = async (page = 0, size = 20) => {
  const { data } = await apiClient.get('/loyalty/transactions', { params: { page, size } });
  return data;
};

/**
 * POST /loyalty/calculate
 * Body: { cartSubtotal }
 * Returns { pointsAvailable, pointsApplicable, discount, rupeesPerPoint, ... }
 */
export const calculateLoyaltyDiscount = async (cartSubtotal) => {
  const { data } = await apiClient.post('/loyalty/calculate', { cartSubtotal });
  return data;
};
